import type { BulkActionAttr } from '@this/components/organization/types';
import { BulkActionAttrServiceType } from '@this/components/organization/types';

const UPSERT_MEMBER_FORMATS: BulkActionAttr[] = [
  {
    name: 'email',
    summary: 'メールアドレス',
    example: 'tanaka.taro@example.com',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'birthday',
    summary: '生年月日',
    example: '2018/04/01',
    required: false,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'gender',
    summary: '性別',
    example: '男性',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'last_name_kana',
    summary: 'カナ姓',
    example: 'タナカ',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'first_name_kana',
    summary: 'カナ名',
    example: 'タロウ',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'last_name',
    summary: '姓',
    example: '田中',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'first_name',
    summary: '名',
    example: '太郎',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'last_name_roman',
    summary: 'ローマ字姓',
    example: 'Tanaka',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'first_name_roman',
    summary: 'ローマ字名',
    example: 'Taro',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'tel',
    summary: '電話番号',
    example: '090123405678',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'sign_in_method',
    summary: 'サインイン方法',
    example: 'SSO：1\nパスワード：0',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'employee_number',
    summary: '社員番号',
    example: '123',
    required: false,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'department_code',
    summary: '部署コード',
    example: '123',
    required: false,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'organization_base_name',
    summary: '拠点名',
    example: '※未入力でお願いいたします',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'domestic_approval_required',
    summary: '国内承認',
    example: '必要：1\n不要：0',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'domestic_notification_required',
    summary: '部署承認者へ通知',
    example: '必要：1\n不要：0',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'foreign_approval_required',
    summary: '海外承認',
    example: '必要：1\n不要：0',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'foreign_notification_requires',
    summary: '部署承認者へ通知',
    example: '必要：1\n不要：0',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'role',
    summary: '役割',
    example: '管理者\n一般ユーザー',
    required: false,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'show_other_members',
    summary: '他ユーザー表示',
    example: '表示：1\n非表示：0',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'grade',
    summary: '役職等級',
    example: '一般\n部長',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'ignore_ip_address_restriction',
    summary: 'IPアドレス制限対象から除外',
    example: '除外する：1\n除外しない：0',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'browsing_scope',
    summary: 'データ閲覧可能範囲',
    example: '全部署：all\n自部署のみ：department',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'show_hotel_of_over_limit',
    summary: '国内規程額超過ホテル表示権限',
    example: '表示：1\n非表示：0',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'show_foreign_hotel_of_over_limit',
    summary: '海外規程額超過ホテル表示権限',
    example: '表示：1\n非表示：0',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'exic_id',
    summary: 'EXIC会員ID',
    example: '例) 0123456789',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'exic_password',
    summary: 'EXICパスワード',
    example: '例) password',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'exic_card',
    summary: 'EXICカード番号',
    example: '1234567890',
    required: false,
    serviceType: BulkActionAttrServiceType.AI_TRAVEL
  },
  {
    name: 'itinerary_approver',
    summary: '旅程ごとの承認者（カスタムワークフローオプション申込時のみ適用）',
    example: '承認者にする：1\n承認者にしない：0',
    required: false,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'business_ekinet_account',
    summary: 'ビジネスえきねっと会員ID',
    example: '1234567890',
    required: false,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'disabled',
    summary: '状態',
    example: '無効：1\n有効：0',
    required: true,
    serviceType: BulkActionAttrServiceType.ALL
  },
  {
    name: 'exic_reference_number',
    summary: 'EXIC整理番号',
    example: '例) 0123456789',
    required: false,
    serviceType: BulkActionAttrServiceType.ADMIN
  }
];

export default UPSERT_MEMBER_FORMATS;
